import React from 'react';
import RegexTextField, { RegexTextFieldProps } from './RegexTextField';

const regexp = new RegExp(/^(\d{3}).(\d{4}).(\d{4}).(\d{2})$/);

const AhvNoTextField: React.FC<RegexTextFieldProps> = ({ label, onChange, onChangeIsValid, required, value, disabled }) => (
  <RegexTextField
    label={label}
    onChange={onChange}
    onChangeIsValid={onChangeIsValid}
    value={value}
    required={required}
    validationRegex={regexp}
    disabled={disabled}
  />
);

export default AhvNoTextField;
